import Modal from 'react-bootstrap/Modal';
import {
    setSigningUp,
    setTransactionUponLogin,
    setShowLogin} from 'actions/index.js';
import { Button } from 'reactstrap';
import ConditionedComponent from 'components/ConditionedComponent.js';
import accounts from 'accounts/Accounts.js';
import React, { Component } from 'react';
import { Badge, Label, InputGroup, InputGroupAddon, InputGroupText, Input } from 'reactstrap';
import { connect } from "react-redux";
import '../../Modals.scss';
import ethereum from 'decentralized/ethereum.js';
import PasswordMask from 'react-password-mask';

/**
 * Modal responsible for sequence-wide changes like
 * double setting the track length
 */
class LoginModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            username: '',
            password: '',
            loginFailed: false,
        };

        this.onClickDone = this.onClickDone.bind(this);
        this.onClickCancel = this.onClickCancel.bind(this);
    }

    handlePasswordChange(p) {
        this.setState({password: p.target.value});
    }

    async onClickDone() {
        if (this.props.signingUp){
            accounts.signUp(this.state.userName, this.state.password);
        } else {
            let result = await accounts.login(this.state.userName, this.state.password);
            if (!result) {
                this.setState({loginFailed: true});
                return;
            }
            if (this.props.transactionUponLogin) {
                this.props.transactionUponLogin.execute();
                this.props.clearTransactions();
            }
            ethereum.guilds.acceptAnyNewRequests();
        }
        this.setState({loginFailed: false});
        this.props.hide();
    }

    onClickCancel() {
        this.props.setSigningUp(false);
        this.props.hide();
    }

    render() {
        return (
            <Modal dialogClassName="preset-modal" show={this.props.show} onHide={this.onClickCancel}>
              <Modal.Header closeButton>
                <Modal.Title>{this.props.signingUp ? 'Sign Up' : 'Log In'}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ConditionedComponent condition={this.state.loginFailed}>
                  The username/password you entered was incorrect. Please try again.
                </ConditionedComponent>
                <ConditionedComponent condition={this.props.transactionUponLogin}>
                  Need to login again to save your transaction with us.
                </ConditionedComponent>
                <InputGroup>
                  <Input
                    onChange={(event) => this.setState({userName: event.target.value})}
                    value={this.state.userName}
                    placeholder="Enter your username" className="email-address-input"/>
                </InputGroup>
                <PasswordMask
                  id="password"
                  name="password"
                  placeholder="Enter password"
                  value={this.state.password}
                  onChange={this.handlePasswordChange.bind(this)}
                    />
                {!this.props.signingUp &&
                 <div className="sign-up-text">
                   No account yet? Chill, you can sign up <span onClick={() => this.props.setSigningUp(true)} className="sign-up-here pushable">here</span>.
                 </div>}
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={this.onClickDone}>
                  Done
                </Button>
                <Button variant="primary" onClick={this.onClickCancel}>
                  Cancel
                </Button>
              </Modal.Footer>
            </Modal>
        );
    }
}
const mapDispatchToProps = dispatch => {
    return {
        setSigningUp: x => dispatch(setSigningUp(x)),
        hide: show=> dispatch(setShowLogin(false)),
        clearTransactions: () => dispatch(setTransactionUponLogin(undefined))
    }
};

const mapStateToProps = state => {
    return {
        transactionUponLogin: state.transactions.transactionUponLogin,
        signingUp: state.sequencer.signingUp,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginModal);
